// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YF_J","left":"styles_left__19kfw"};